import React from "react";
import { Link } from "react-router-dom";
import { useContent } from "../hooks/useContent";
import { useLang } from "../context/LanguageContext";
import { SEO } from "../components/SEO";
import { PageHeader } from "../components/PageHeader";
import { Reveal } from "../components/motion/Reveal";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";

export default function FAQ() {
  const { t, tc } = useLang();
  const { data: faqs } = useContent("faqs");

  const schema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((f) => ({
      "@type": "Question",
      name: tc(f.question),
      acceptedAnswer: { "@type": "Answer", text: tc(f.answer) },
    })),
  };

  return (
    <>
      <SEO pageKey="faq" title={t.seo.faq.title} description={t.seo.faq.description} schema={schema} />
      <PageHeader pageKey="faq"
        overline={t.faq.overline}
        title={t.faq.title}
        image="https://images.unsplash.com/photo-1473968512647-3e447244af8f?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000"
      />
      <section className="py-10 sm:py-14 bg-white">
        <div className="max-w-[820px] mx-auto px-5 sm:px-8">
          <Reveal>
            <Accordion type="single" collapsible className="space-y-4" data-testid="faq-accordion">
              {faqs.map((f, i) => (
                <AccordionItem key={f.id} value={`item-${i}`} className="border border-border rounded-2xl px-6 data-[state=open]:border-gold/40 data-[state=open]:bg-lightgray/50 transition-colors">
                  <AccordionTrigger data-testid={`faq-trigger-${i}`} className="text-start font-display text-lg text-charcoal hover:no-underline py-5">
                    {tc(f.question)}
                  </AccordionTrigger>
                  <AccordionContent className="text-charcoal/65 leading-relaxed text-[15px] pb-5">
                    {tc(f.answer)}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </Reveal>

          <Reveal delay={0.1}>
            <div className="mt-14 text-center bg-green rounded-3xl p-10 grain">
              <p className="font-display text-2xl text-white mb-2">{t.faq.stillQuestions}</p>
              <Link to="/contact" data-testid="faq-contact-cta" className="inline-flex mt-4 rounded-full bg-gold text-charcoal font-semibold px-7 py-3.5 hover:bg-gold-soft transition-colors">
                {t.faq.contactUs}
              </Link>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
